import { render } from "./ContactComponent.vue?vue&type=template&id=74533a34&ts=true"
import script from "./ContactComponent.vue?vue&type=script&lang=ts"
export * from "./ContactComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__